import { captureAttribution } from "@/lib/marketingAnalytics";
import {
  Spade, Swords, Flame, Zap, Skull, Gamepad2, Crosshair, Shield, Sparkles, Trophy,
} from "lucide-react";

const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").trim();
const isLocalBrowser = ["localhost", "127.0.0.1"].includes(window.location.hostname);
const defaultBackendUrl = isLocalBrowser ? "http://localhost:8000" : "https://api.gameplatplay.com";
export const BACKEND_URL = (configuredBackendUrl || defaultBackendUrl).replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;
export const SESSION_KEY = "gameplat_session_token";

export function authHeaders(headers = {}) {
  const token = window.localStorage.getItem(SESSION_KEY);
  return token ? { ...headers, Authorization: `Bearer ${token}` } : headers;
}

export function apiFetch(path, options = {}) {
  return fetch(`${API}${path}`, {
    ...options,
    credentials: "include",
    headers: authHeaders({ "X-Campaign": JSON.stringify(captureAttribution()), ...(options.headers || {}) }),
  });
}

export const ASSETS = {
  bg: "/yorick-home-mask-v3.webp",
  logo: "/gameplatplay-logo.svg",
  avatar: "/yorick-avatar-blue.png",
  chatPortrait: "/yorick-chat-mask-v1.webp",
};

// Visual style per featured game id
export const GAME_STYLES = {
  balatro: { icon: Spade, from: "#f0c040", to: "#b8860b" },
  "slay-the-spire": { icon: Swords, from: "#fe5f55", to: "#8b2e2a" },
  hades: { icon: Flame, from: "#009dff", to: "#0a4a7a" },
  "marvel-snap": { icon: Zap, from: "#9b59b6", to: "#4a2a63" },
  "vampire-survivors": { icon: Skull, from: "#50c878", to: "#1f5738" },
};

export const SHOWCASE_ICONS = {
  "gta-6": Crosshair,
  "cod-warfare": Crosshair,
  "battlefield-6": Shield,
  "elden-ring": Trophy,
  "cyberpunk-2077": Sparkles,
  default: Gamepad2,
};

export const DISCORD_URL = "";
export const BALATRO_STORE_URL = "https://store.steampowered.com/app/2379780/Balatro/";

export function getSessionId() {
  let id = localStorage.getItem("gp_session_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("gp_session_id", id);
  }
  return id;
}
